import { Box, Grid, Typography } from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import { styles } from './styles.ts';

type InformationMessageBlockProps = {
  informationText: string;
};

export const InformationMessageBlock = ({ informationText }: InformationMessageBlockProps) => {
  return (
    <Grid container spacing={3}>
      <Box sx={styles.block}>
        <InfoOutlineIcon sx={styles.icon} />
        <Typography variant={'body1'} sx={styles.infoText}>
          {informationText}
        </Typography>
      </Box>
    </Grid>
  );
};
